export default __webpack_public_path__ + "static/media/gallery06.cb094c73.jpg";